<!DOCTYPE html>
@if (charityPageData$ | async; as charity) {
  <ion-content #pageTop>
    <div class="main-container">
      <ion-row class="top-header">
        <ion-col class="heading-wrap ion-no-padding" size="11">
          <h1 class="page-heading">{{"charity.charity_heading" | translate}}</h1>
        </ion-col>
        <ion-col class="notification-wrap ion-no-padding" size="1" (click)="backToHomePage()">
          <img class="support-img" src="assets/images/close-circle.png" />
        </ion-col>
      </ion-row>
      <div class="charitycard-wrapper big_charity">
        <ion-card>
          <img class="card-image" src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/app%2Fyflower_200x200.webp?alt=media" />
          <ion-card-header>
            <img class="card-subimage" src="../../../assets/images/hopesub.png" />
          </ion-card-header>
          <ion-card-content>
            <h2 class="main-title">{{ "charity.Why" | translate }}</h2>
            <p class="main-desc">
              {{ "charity.hope.herodescription" | translate }}
            </p>
            @if (charity[0]?.hope?.hope_web_link) {
              <p class="more-link">{{ charity[0]?.hope?.button_label }}</p>
            }
          </ion-card-content>
        </ion-card>
      </div>
      <div class="charitycard-wrapper charity-month">
        <ion-card>
          <ion-card-content>
            <h2 class="main-title">{{ "charity.charity_of_the_month.title" | translate }}</h2>
            <p class="main-desc">
              {{ "charity.hope.description" | translate }}
            </p>
            <p class="thanks-text">{{"charity.thanks_for_voting" | translate}}</p>
          </ion-card-content>
        </ion-card>
      </div>
      <div class="charitycard-wrapper card-dogssup">
        <ion-card class="ion-card-gradient">
          <h2 class="card-title">
            {{
            charity[1]?.content[0]?._charity_name && charity[1]?.content[0]?._charity_name[selectedLanguage]
            ? charity[1]?.content[0]?._charity_name[selectedLanguage]
            : charity[1]?.content[0]?.charity_name
            }}
          </h2>
          <img class="card-image" src="{{ charity[1]?.content[0]?.charity_image }}" />
          <ion-card-header>
            <img class="card-subimage1" src="{{ charity[1]?.content[0]?.charity_logo }}" />
          </ion-card-header>
          <ion-card-content>
            {{
            charity[1]?.content[0]?._charity_long_description &&
            charity[1]?.content[0]?._charity_long_description[selectedLanguage]
            ? charity[1]?.content[0]?._charity_long_description[selectedLanguage]
            : charity[1]?.content[0]?.charity_long_description
            }}
            <div class="pbar">
              <div class="progress orange"><span class="fill"></span></div>
              <p class="text-orange">{{ charity[1]?.content[0]?.charity_percentage | number: "1.2-2" }}%</p>
            </div>
            @if (charity[1]?.content[0]?.charity_web_link) {
              <a
                class="more-link"
                target="_blank"
                href="{{ charity[1]?.content[0]?.charity_web_link }}"
                >{{
                charity[1]?.content[0]?._link_label && charity[1]?.content[0]?._link_label[selectedLanguage]
                ? charity[1]?.content[0]?._link_label[selectedLanguage]
                : charity[1]?.content[0]?.link_label
                }}</a
                >
              }
            </ion-card-content>
          </ion-card>
        </div>
        <div class="charitycard-wrapper card-red">
          <ion-card class="ion-card-gradient">
            <h2 class="card-title">
              {{
              charity[1]?.content[1]?._charity_name && charity[1]?.content[1]?._charity_name[selectedLanguage]
              ? charity[1]?.content[1]?._charity_name[selectedLanguage]
              : charity[1]?.content[1]?.charity_name
              }}
            </h2>
            <img class="card-image" src="{{ charity[1]?.content[1]?.charity_image }}" />
            <ion-card-header>
              <img class="card-subimage1" src="{{ charity[1]?.content[1]?.charity_logo }}" />
            </ion-card-header>
            <ion-card-content>
              {{
              charity[1]?.content[1]?._charity_long_description &&
              charity[1]?.content[1]?._charity_long_description[selectedLanguage]
              ? charity[1]?.content[1]?._charity_long_description[selectedLanguage]
              : charity[1]?.content[1]?.charity_long_description
              }}
              <div class="pbar">
                <div class="progress red"><span class="fill"></span></div>
                <p class="text-red">{{ charity[1]?.content[1]?.charity_percentage | number: "1.2-2" }}%</p>
              </div>
              @if (charity[1]?.content[1]?.charity_web_link) {
                <a
                  class="more-link"
                  target="_blank"
                  href="{{ charity[1]?.content[1]?.charity_web_link }}"
                  >{{
                  charity[1]?.content[1]?._link_label && charity[1]?.content[1]?._link_label[selectedLanguage]
                  ? charity[1]?.content[1]?._link_label[selectedLanguage]
                  : charity[1]?.content[1]?.link_label
                  }}</a
                  >
                }
              </ion-card-content>
            </ion-card>
          </div>
          <ion-card class="bigs-card">
            <ion-card-content class="no-ypadding">
              <h2 class="top-title">{{ "charity.results_for" | translate}} {{ lastMonth }}</h2>
              <div class="bor-b block">
                <div class="chart-container">
                  <canvas id="doughnutchart" #doughnutCanvas style="position: relative; height: 20vh; width: 40vw"> </canvas>
                  <div class="round-card red-card">
                    <div class="data-wrapper">
                      <h2>{{ charity[2]?.content[0]?.charity_percentage | number: "1.0-0" }}%</h2>
                      <p>
                        {{
                        charity[2]?.content[0]?._charity_name && charity[2]?.content[0]?._charity_name[selectedLanguage]
                        ? charity[2]?.content[0]?._charity_name[selectedLanguage]
                        : charity[2]?.content[0]?.charity_name
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="round-card oringe-card">
                    <div class="data-wrapper">
                      <h2>{{ charity[2]?.content[1]?.charity_percentage | number: "1.0-0" }}%</h2>
                      <p>
                        {{
                        charity[2]?.content[1]?._charity_name && charity[2]?.content[1]?._charity_name[selectedLanguage]
                        ? charity[2]?.content[1]?._charity_name[selectedLanguage]
                        : charity[2]?.content[1]?.charity_name
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="bor-b block fimag">
                <img class="card-subimage" src="{{ charity[2]?.content[0]?.charity_logo }}" />
                <h3 class="main-title">
                  {{ charity[2]?.content[0]?.charity_name }}
                </h3>
                <p class="main-desc">
                  {{
                  charity[2]?.content[0]?._charity_long_description &&
                  charity[2]?.content[0]?._charity_long_description[selectedLanguage]
                  ? charity[2]?.content[0]?._charity_long_description[selectedLanguage]
                  : charity[2]?.content[0]?.charity_long_description
                  }}
                </p>
              </div>
              <div class="block simag">
                <img class="card-subimage" src="{{ charity[2]?.content[1]?.charity_logo }}" />
                <h3 class="main-title">
                  {{ charity[2]?.content[1]?.charity_name }}
                </h3>
                <p class="main-desc">
                  {{
                  charity[2]?.content[1]?._charity_long_description &&
                  charity[2]?.content[1]?._charity_long_description[selectedLanguage]
                  ? charity[2]?.content[1]?._charity_long_description[selectedLanguage]
                  : charity[2]?.content[1]?.charity_long_description
                  }}
                </p>
              </div>
            </ion-card-content>
          </ion-card>
        </div>
        <div class="slider-wrapper">
          <swiper #slider [config]="sliderOptions" class="home-slider" #homePageCardsSlider>
            <ng-template swiperSlide class="card-slider">
              <ion-card class="slider-size-spec">
                <div class="quotes-card">
                  <p class="quotes-text">
                    “{{ charity[3]?.content?.[0]?.[selectedLanguage]?.quote_description || 'description unavailable' }}”<br /><span class="quotes-by">{{
                    charity[3]?.content?.[0]?.[selectedLanguage]?.quote_name || 'quote_name unavailable'
                  }}</span>
                </p>
              </div>
            </ion-card>
          </ng-template>
          <ng-template swiperSlide class="card-slider">
            <ion-card class="slider-size-spec">
              <div class="quotes-card">
                <p class="quotes-text">
                  “{{ charity[3]?.content[1]?.[selectedLanguage]?.quote_description }}”<br /><span class="quotes-by">{{
                  charity[3]?.content[1]?.[selectedLanguage]?.quote_name
                }}</span>
              </p>
            </div>
          </ion-card>
        </ng-template>
      </swiper>
    </div>
    <div class="main-container">
      <ion-card class="multicard-grid box-shadow-none heartp-card">
        <div class="support-center">
          <ion-card-header>
            <img src="assets/images/heartp.png" />
            <h2 class="main-title">{{ "charity.keep_syndicate_alive.title" | translate }}</h2>
          </ion-card-header>
          <ion-card-content>
            <p class="main-desc">
              {{ "charity.keep_syndicate_alive.description" | translate }}
            </p>
          </ion-card-content>
        </div>
      </ion-card>
    </div>
  </ion-content>
}